module.exports = __webpack_public_path__ + "img/mobilehomepagescale.a7764584.png";